import { MarkdownToJSX } from '@/components/MarkdownToJSX';
import { HtmlEditorFragment } from '@/utils/dato/generated';

// Tables pasted from Google Sheets carry <colgroup> widths that add up to >100%,
// causing columns to overflow and visually overlap. Strip the colgroup so the
// table uses equal-width columns from table-layout: fixed instead.
const cleanTableHtml = (html: string): string =>
  html.replace(/<colgroup[^>]*>[\s\S]*?<\/colgroup>/gi, '').replace(/\*(?![^<]*>)/g, '\\*');

const HtmlEditor = ({ html }: HtmlEditorFragment) => <MarkdownToJSX md={cleanTableHtml(html || '')} />;

export default HtmlEditor;
